import { render, staticRenderFns } from "./ConfigurationItemsPriceList.vue?vue&type=template&id=541b77ee&"
import script from "./ConfigurationItemsPriceList.vue?vue&type=script&lang=ts&"
export * from "./ConfigurationItemsPriceList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports